class Card {
  constructor() {}

  static copyLink(button) {
    const input = button.previousElementSibling;
    if (input && input.tagName === 'INPUT') {
      // console.debug(input.value);

      try {
        input.select();
        navigator.clipboard.writeText(input.value);

        // TODO: Toast for user feedback? Is selecting the text enough?
        // No design was provided for it.
      } catch (err) {
        console.error(err);
      }
    }
  }
}

export default Card;
